import { RFC_2822 } from "moment";
import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerEstadoAutorizacion = async (usuarioId) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerEstadoAutorizacion",usuarioId,customConfig);
        
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ObtenerEstadoAutorizacion };
